<template>
    <div class="panel_container">
        <img src="@/assets/home/homev2_bottom_bg.png" alt="">
        <div class="bottom_icon">
            <img src="@/assets/home/homev2_bottom_icon_77.png" alt="">
        </div>


        <van-row class="btn_section">
            <van-col v-if="iosData.display" span="12" class="download_item">
                <img :src="iosData.url" alt="">
                <div class="download_btn"
                    :style="{ color: customStyle.color, border: `1px solid ${customStyle.color}` }"
                    @click="goToLink(iosData.redirect_url)">{{ iosData.text }}</div>
            </van-col>
            <van-col v-if="androidData.display" span="12" class="download_item">
                <img :src="androidData.url" alt="">
                <div class="download_btn"
                    :style="{ color: customStyle.color, border: `1px solid ${customStyle.color}` }"
                    @click="goToLink(androidData.redirect_url)">{{ androidData.text }}</div>
            </van-col>
        </van-row>
        <van-row class="bottom_section">
            <van-col span="14" class="transfer_btn">
                <img src="@/assets/home/homev2_bottom_icon_download.png" alt="">
                {{ $t('home.transfer') }}
            </van-col>
            <van-col span="10" class="logo">
                <img src="@/assets/common/logo_688v.png" alt="">
            </van-col>
        </van-row>

    </div>
</template>

<script setup lang="ts">
import { goToLink } from '@/view/home/supportScript';
import { defineProps, onMounted, ref } from 'vue'

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = defineProps<{
    itemData: {
        ios: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        android: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        styles: {
            color: string
        }
    }
}>()

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})

</script>
<style scoped>
.panel_container {
    position: relative;
}

.panel_container img {
    width: 100%;
}

.bottom_icon img {
    position: absolute;
    right: 15px;
    top: 0;
    width: 28vw;
}

.download_item {
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.download_item img {
    width: 10vw;
    height: 10vw;
}

.download_btn {
    /* border: 1px solid #DD7A33;
    color: #DD7A33; */
    border-radius: 5px;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16vw;
    margin-top: 5px;
}

@media (min-width: 450px) {
  .bottom_icon img {
    width: 150px;
  }
  .download_item img {
    width: 45px;
    height: 45px;
  }
  .download_btn {
    width: 60px;
  }
}

.btn_section {
    position: absolute;
    top: 55px;
    left: 10px;
}

.transfer_btn {
    color: #fff;
    font-weight: bold;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.transfer_btn img {
    width: 25px;
    padding-right: 10px;
}

.logo img {
    width: 110px;
}

.logo {
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom_section {
    position: relative;
    margin-top: -65px;
}

@media (max-width:400px) {
    .bottom_section {
        margin-top: -45px;
    }
}
</style>